import * as React from "react";
const SvgFiRrMoonStars = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-moon-stars_svg__a)">
      <path
        fill="#062147"
        d="M12.01 24A12.066 12.066 0 0 1 .074 10.725 12.12 12.12 0 0 1 10.1.152a13 13 0 0 1 5.03.206 2.5 2.5 0 0 1 1.783 3.108 2.47 2.47 0 0 1-.683 1.117c-4.559 4.168-4.165 10.645.807 14.412a2.5 2.5 0 0 1-.7 4.319A13.9 13.9 0 0 1 12.01 24m.073-22q-.841-.003-1.675.127a10.1 10.1 0 0 0-8.344 8.8A9.93 9.93 0 0 0 4.581 18.7a10.47 10.47 0 0 0 11.093 2.734.5.5 0 0 0 .138-.856C9.883 16.1 9.417 8.087 14.865 3.124a.46.46 0 0 0 .127-.465.49.49 0 0 0-.356-.362A10.7 10.7 0 0 0 12.083 2M20.5 12a1 1 0 0 1-.97-.757l-.358-1.43-1.432-.385a1 1 0 0 1 .035-1.94l1.4-.325.351-1.406a1 1 0 0 1 1.94 0l.355 1.418 1.418.355a1 1 0 0 1 0 1.94l-1.418.355-.355 1.418A1 1 0 0 1 20.5 12M16 14a1 1 0 1 0 2 0 1 1 0 0 0-2 0m6 4a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-moon-stars_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMoonStars;
